<template>
  <div>
    <!-- <div class="p" @click="userFlag = !userFlag">申请列表</div> -->
    <transition
      enter-active-class="animated fadeInRight"
      leave-active-class="animated fadeOutRight"
    >
      <div class="userList" v-show="userFlag">
        <div class="title">
          <p>LIST</p>
          <img
            src="../assets/newImg/callclose.png"
            class="close"
            @click="userFlag = false"
          />
        </div>

        <div class="box">
          <div class="list">
            <div class="title1">APPLICATION</div>

            <div v-for="(item, index) in applyList" :key="index">
              <div class="item a">
                {{ item.name }}
                <div style="display: flex">
                  <div
                    class="icon"
                    style="margin-right: 5px"
                    @click="apply(true, item.id)"
                  >
                    √
                  </div>
                  <div class="icon" @click="apply(false, item.id)">x</div>
                </div>
              </div>
            </div>
          </div>

          <div class="list">
            <div class="title2">ROOM</div>

            <div v-for="(item, index) in playerList" :key="index">
              <div class="item b" v-if="item.vip != 5">
                {{ item.name }}
                <div style="display: flex">
                  <div class="icon" @click="yaoqing(item)" v-if="!item.flag">+</div>

                  <div
                    class="icon"
                    @click="tc(item)"
                    v-if="item.flag"
                    style="margin-left: 5px"
                  >
                    -
                  </div>

                  <div class="icon" @click="cs(item)" style="margin-left: 5px">→</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- <transition
      enter-active-class="animated fadeInRight"
      leave-active-class="animated fadeOutRight"
    >
      <div class="userList2" v-if="daikanFlag">
        <p>正在进行销售带看</p>
        <img src="../assets/newImg/callclose.png" class="close" @click="close()" />
      </div>
    </transition> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      userFlag: false,
      flag: false,
      name: "",
      id: "",
      daikanFlag: false,
      playerList: [],
      applyList: [],
    };
  },
  methods: {
    func(a, b, c) {
      this.list.splice(b, 1);
    },
    apply(e, id) {
      var num = Number(this.$chat.role.id);
      let info = { msg: "callapply", data: id, flag: e, num };
      let str = 1056 + "," + JSON.stringify(info);
      this.$chat.ws.send(str);
      var i = this.applyList.findIndex((element) => {
        return element.id == id;
      });
      if (e) {
        this.daikanFlag = true;

        this.playerList[i].flag = true;
      }

      this.applyList.splice(i, 1);
    },

    close() {
      let info = { msg: "callclose", data: this.id };
      let str = 1056 + "," + JSON.stringify(info);
      this.$chat.ws.send(str);

      this.daikanFlag = false;
    },

    yaoqing(e) {
      var num = Number(this.$chat.role.id);
      let info = { msg: "yaoqing", data: e.id, num };
      console.log(info);
      let str = 1056 + "," + JSON.stringify(info);
      this.$chat.ws.send(str);
    },

    tc(e) {
      var num = Number(this.$chat.role.id);
      let info = { msg: "tc", data: e.id, num };
      console.log(info);
      let str = 1056 + "," + JSON.stringify(info);
      this.$chat.ws.send(str);
    },

    cs(e) {
      document.o2.teleport_to(e);
    },
  },
  mounted() {
    this.Bus.$on("call", (e) => {
      if (this.$chat.role.auth == 5) {
        var data = {
          id: e.data,
          name: this.$chat.searchName(e.data),
        };
        if (e.flag) {
          this.userFlag = true;
          this.applyList.push(data);
        } else {
          var i = this.applyList.findIndex((element) => {
            console.log(element.id, e.data);
            return element.id == e.data;
          });

          this.applyList.splice(i, 1);
        }
      }
    });

    this.Bus.$on("yaoqingapply", (e) => {
      console.log(e);
      if (this.$chat.role.id == e.data) {
        if (e.flag) {
          var i = this.playerList.findIndex((element) => {
            return element.id == e.id;
          });

          this.playerList[i].flag = true;
          this.daikanFlag = true;
          this.$message.success("您的邀请已被接受");
        } else {
          this.$message.error("您的邀请已被拒绝");
        }
      }
    });

    this.Bus.$on("tc", (e) => {
      console.log(e);

      var i = this.playerList.findIndex((element) => {
        return element.id == e.data;
      });

      this.playerList[i].flag = false;
    });

    this.Bus.$on("sales", (e) => {
      this.userFlag = true;
    });

    this.Bus.$on("tuichudaikan", (e) => {
      var i = this.playerList.findIndex((element) => {
        return element.id == e.id;
      });

      if (this.playerList[i].flag == true) {
        var name = this.$chat.searchName(e.id);
        this.$message.error(`${name}已退出语音房间`);
        this.playerList[i].flag = false;
      }
    });
  },
  created() {
    this.Bus.$on("playerList", (e) => {
      this.playerList = e;
    });
  },
};
</script>

<style lang="scss" scoped>
.userList {
  width: 510px;
  height: 400px;
  background: linear-gradient(
    0deg,
    rgba(233, 238, 242, 0.94) 0%,
    rgba(214, 220, 231, 0.94) 100%
  );
  opacity: 0.94;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  // background: url("../assets/newImg/callbox.png");
  font-family: BMW Group, BMW Group-Bold;
  font-weight: 700;
  .title {
    height: 40px;
    background: url("../assets/newImg/calltitle.png");
    display: flex;
    justify-content: space-between;
    padding: 0 20px;
    align-items: center;
    p {
      font-size: 16.01px;

      font-weight: 700;
      text-align: left;
      color: #fff;
    }
  }

  .box {
    width: 100%;
    display: flex;
    height: 360px;

    .list {
      width: 50%;
      color: #536b8e;
      font-size: 16px;
      .title1 {
        display: flex;
        align-items: center;
        padding-left: 15px;
        height: 40px;
        background: linear-gradient(to right, #fde517 0%, rgba(255, 255, 255, 0) 100%);
      }

      .title2 {
        display: flex;
        align-items: center;
        padding-left: 15px;
        height: 40px;
        background: linear-gradient(to right, #34fdff 0%, rgba(255, 255, 255, 0) 100%);
      }

      .item {
        display: flex;
        justify-content: space-between;
        padding: 0 15px;
        align-items: center;
        height: 40px;
        background: linear-gradient(#ffffff 0%, rgba(255, 255, 255, 0) 100%);
      }
      .a {
        background: rgba(255, 255, 255, 0.94);
        margin-bottom: 1px;
      }
      .b {
        background: rgba(235, 239, 244, 0.94);
        margin-bottom: 1px;
      }
    }
  }
}

.userList2 {
  width: 300px;
  height: 42px;
  opacity: 0.94;
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  margin: auto;
  height: 42px;
  background: url("../assets/newImg/calltitle.png");
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  align-items: center;
  color: white;
}

.icon {
  width: 20px;
  height: 20px;
  background: url("../assets/newImg/callok.png");
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 12px;
}

.close {
  width: 21.34px;
  height: 21.34px;
  cursor: pointer;
}
</style>
